import axios from 'axios';
import { BASE_URL } from './api';

// The user's own folders for filing threads. Personal: the API only ever
// returns and accepts the requesting user's folders. Unpaginated -- a bare list
// in sidebar order.
export async function getOutreachFolders(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/outreach-folders/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((response) => response.data)
    .catch((error) => { throw error });
}

export async function createOutreachFolder(name, token) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/outreach-folders/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { name },
    }).then((response) => response.data)
    .catch((error) => { throw error });
}

export async function updateOutreachFolder(id, data, token) {
    return axios({
        method: 'patch',
        url: `${BASE_URL}/outreach-folders/${id}/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data,
    }).then((response) => response.data)
    .catch((error) => { throw error });
}

// Its threads go back to the Inbox.
export async function deleteOutreachFolder(id, token) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/outreach-folders/${id}/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((response) => response.data)
    .catch((error) => { throw error });
}
